import { render, staticRenderFns } from "./insBaseValue.vue?vue&type=template&id=0b9368a4&scoped=true"
import script from "./insBaseValue.vue?vue&type=script&lang=js"
export * from "./insBaseValue.vue?vue&type=script&lang=js"
import style0 from "./insBaseValue.vue?vue&type=style&index=0&id=0b9368a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9368a4",
  null
  
)

export default component.exports